import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Menu } from './components/Menu';
import { Location } from './components/Location';
import { Hours } from './components/Hours';
import { Social } from './components/Social';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-body text-charcoal selection:bg-orange selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Menu data-id="element-5" />
        <Location data-id="element-6" />
        <Hours data-id="element-7" />
        <Social data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}